import StarknetWalletConnector from '../starknetWalletConnector.js';

class Okx extends StarknetWalletConnector {
    constructor(opts) {
        super('OKX Starknet', 'okxwallet', opts);
        this.overrideKey = 'okxstarknet';
    }
}

export { Okx };
